import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_INTERNSHIP_SERVICES, 
    ADD_NEW_INTERNSHIP_SERVICE, 
    UPDATE_INTERNSHIP_SERVICE, 
    DELETE_INTERNSHIP_SERVICE 
} from "./actionTypes";
import {
    getInternshipServicesSuccess,
    getInternshipServicesFail,
    addInternshipServiceSuccess,
    addInternshipServiceFail,
    updateInternshipServiceSuccess,
    updateInternshipServiceFail,
    deleteInternshipServiceSuccess,
    deleteInternshipServiceFail,
   
} from "./actions"

import {
    getInternshipServices,
    addNewInternshipService,
    updateInternshipService,
    deleteInternshipService,
   
} from "helpers/internship-services/internship_services_backend_helper";
import { toast } from "react-toastify";

function* fetchInernshipServices() {
    try {
        const response = yield call(getInternshipServices)

        yield put(getInternshipServicesSuccess(response))
    } catch (error) {
        yield put(getInternshipServicesFail(error))
    }
}

function* onAddNewInternshipService({ payload }) {
    try {

        
        const response = yield call(addNewInternshipService, payload)

        console.log("RESPONSE:", response);
        yield put(addInternshipServiceSuccess(response.internshipService))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addInternshipServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateInternshipService({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateInternshipService, payload)
        yield put(updateInternshipServiceSuccess(response.internshipService))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateInternshipServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteInternshipService({ payload: data }) {

    try {
        const response = yield call(deleteInternshipService, data)
        yield put(deleteInternshipServiceSuccess(response.internshipServiceId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteInternshipServiceFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* internshipSaga() {
    yield takeEvery(GET_INTERNSHIP_SERVICES, fetchInernshipServices)
    yield takeEvery(ADD_NEW_INTERNSHIP_SERVICE, onAddNewInternshipService)
    yield takeEvery(UPDATE_INTERNSHIP_SERVICE, onUpdateInternshipService)
    yield takeEvery(DELETE_INTERNSHIP_SERVICE, onDeleteInternshipService)
}

export default internshipSaga;